const selectEventTypesReducer = state => state.eventTypes;

export const selectActiveOrganizations = state =>
  selectEventTypesReducer(state).activeOrganizations;

export const selectDefaultStatus = state => selectEventTypesReducer(state).default;
